import { ILeadRaw } from 'models/lead.model'
import { subscriptionsApi } from 'nove8/api'
import { ProcessingKey } from 'nove8/constants/root-constants'
import { DEFAULT_COHORT, WEBAPP_COHORT } from 'root-constants'
import { useZustandGlobalLocalStore } from 'zustandGlobalLocalStore'
import { useZustandStore } from 'zustandGlobalStore'
import { fetchGeoData } from './fetchGeoData'
import { updateLeadWithEmail } from './updateLeadWithEmail'

export const fetchLead = async (leadId: string): Promise<void> => {
  useZustandStore.getState().startProcessing(ProcessingKey.FETCH_LEAD)

  const cohort =
    useZustandStore.getState().lead?.cohort ||
    useZustandStore.getState().initialCohort
  const searchParams = new URLSearchParams(window.location.search)

  const response = await subscriptionsApi.getLead({ leadId, cohort })
  const geoDataResponse = await fetchGeoData()

  if (geoDataResponse?.region) {
    useZustandStore.setState({ geoRegion: geoDataResponse.region })
  }
  if (geoDataResponse?.city) {
    useZustandStore.setState({ geoCity: geoDataResponse.city })
  }

  if (response?.data && response?.success) {
    const lead: ILeadRaw = response.data

    useZustandStore.setState({ lead })
    useZustandGlobalLocalStore.setState((state) => ({
      previousLeadId: state.previousLeadId || lead.id,
    }))

    const email = searchParams.get('email')

    if (!lead.email && cohort === WEBAPP_COHORT && email) {
      await updateLeadWithEmail({ email })
    }
  }

  if (
    !response.success &&
    (response.status === 404 || response.data.status === 'INVALID_ARGUMENT')
  ) {
    // if the leadId from old subscriptions, redirect to the fallback cohort
    if (!!leadId && !leadId.startsWith('lead-')) {
      searchParams.set('cohort', DEFAULT_COHORT)
      searchParams.delete('uuid')
      // use window.location.search to reload the page with updated query params
      window.location.search = `?${searchParams}`
      useZustandStore.getState().stopProcessing(ProcessingKey.FETCH_LEAD)
      return
    }

    searchParams.delete('uuid')
    // use window.location.search to reload the page with updated query params
    window.location.search = `?${searchParams}`
  }

  useZustandStore.getState().stopProcessing(ProcessingKey.FETCH_LEAD)
}
